import React from "react"
import { Link } from "react-router-dom"
import About from "../Components/About/About"
import Path from "../Components/Path/Path"
import Programes from "../Components/Programes/Programes"
import Blog from "../Components/Blog/Blog"
import Footer from '../Components/Outlets/Footer'
import Nav from '../Components/Outlets/Nav'
import faq from '../Assets/faq.png'	
const HomePage = () => {

	return (
		<div>
			<Nav />
			<div className="page-main">
				<div className='home-page'>
					<div className="container-main">
						<div className="home-page-content">
							<h1 className="home-main-heading montserrat">Rooted in Knowledge, Blossoming with <span className="montserrat block-text">Strength: Q-Garden</span> </h1>
							<p className="home-sub-text">Q-Garden is the scriptural abode for women that is driven by ‘ women empowerment through education’ maxim. This insti- tution is believed to breed the motherly generation equipped with calibre of self making and life framing on the onset of mod- ern threat to motherhood and deprived childhood.</p>
							<Link className="btn enquire-btn" to='/admission'>Admission  -  2025</Link>
						</div>
					</div>
				</div>
				<About />
				<Path />
				<Programes />
				<Blog />
				<div className="faq-section-main">
					<div className="container-main">
						<div className="row">
							<div className="col-lg-6">
								<div className="faq-inner">
									<h1 className='faq-title'>FAQ</h1>

									<div class="accordion" id="accordionExample">
										<div class="accordion-item">
											<h2 class="accordion-header" id="headingOne">
												<button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
													Why Qgarden ?
												</button>
											</h2>
											<div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
												<div class="accordion-body">
												Q-Garden is the scriptural abode for women that is driven by ‘ women empowerment through education’ maxim. This insti- tution is believed to breed the motherly generation equipped with calibre of self making and life framing on the onset of mod- ern threat to motherhood and deprived childhood.
												</div>
											</div>
										</div>
										<div class="accordion-item">
											<h2 class="accordion-header" id="headingTwo">
												<button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
												What is Rose Garden 
												</button>
											</h2>
											<div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
												<div class="accordion-body">
												Women empowerment is universal aim which has been called for since antiqui- ty. We believe in the power of education in flourishing that aim as true knowledge leads to both spiritual and physical emancipation. Rose garden develops a one stop centre that amalgamates versatile knowledge im- parts with focusing equally on self transfor- mation.
												</div>
											</div>
										</div>
										<div class="accordion-item">
											<h2 class="accordion-header" id="headingThree">
												<button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
												Curriculum 
												</button>
											</h2>
											<div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
												<div class="accordion-body">
												Psychologically administered pedagogy that can boost memorizing skills along with inculcation analytic vigor
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="col-lg-6">
								<div className="faq-inner">
									<img src={faq} className='faq-main' alt="" />
								</div>
							</div>
						</div>
					</div>
				</div>

			</div>
			<Footer />
		</div>
	)
}

export default HomePage;